import React from 'react';
import I18n from 'app/i18n';
import {Link} from 'react-router-dom';
import {getLinkPath} from 'app/utils/link_helper';
import {userStore} from 'app/store/global';
import {betMoney} from 'app/utils';
import {observer} from 'mobx-react';

interface Props {
    onClose?: () => void;
}

@observer
export default class CashbackBalanceTooltip extends React.Component<Props> {
    onClose = (): void => {
        this.props.onClose?.();
    };

    render(): React.ReactNode {
        const {cashback_real_rate, cashback_remaining_balance} = userStore.user || {};
        const realRatePercentValue = (cashback_real_rate ?? 0) * 100;
        const realRatePercent = `${realRatePercentValue.toFixed(0)}%`;
        const nextRatePercent = `${(realRatePercentValue + 1).toFixed(0)}%`;
        const remainingBalance = Number(cashback_remaining_balance) || 0;
        const remainingBalanceFormatted = betMoney({amount: remainingBalance}, 0, false, true) || '0';

        return <>
            <span>{I18n.t('user_cashback')}</span>
            <p>{I18n.t('user_cashback_description')}</p>
            <div className="details">
                <p>{I18n.t('user_cashback_current_rate')} - {realRatePercent}</p>
                <p>{I18n.t('user_cashback_remaining_balance', {amount: remainingBalanceFormatted, percent: nextRatePercent})}</p>
            </div>
            <Link to={getLinkPath('/faq/weekly-cashback')} onClick={this.onClose}>
                {I18n.t('read_more_u')}
            </Link>
        </>;
    }
}
